var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "gzh-qrcode" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading"
          }
        ],
        staticClass: "gzh-qrcode__content"
      },
      [
        !_vm.isBind
          ? [
              _c("div", { staticClass: "gzh-qrcode__tips" }, [
                _vm._v("扫码关注接收验证码")
              ]),
              _vm._v(" "),
              _c(
                "el-image",
                {
                  staticStyle: { width: "100%", height: "100%" },
                  attrs: { src: _vm.qrCode }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "image-slot",
                      attrs: { slot: "error" },
                      slot: "error"
                    },
                    [_c("i", { staticClass: "el-icon-picture-outline" })]
                  )
                ]
              ),
              _vm._v(" "),
              _vm.isExpire
                ? _c(
                    "div",
                    { staticClass: "gzh-qrcode__refresh" },
                    [
                      _c("div", { staticClass: "refresh_tips" }, [
                        _vm._v("二维码已过期")
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            icon: "el-icon-refresh-right"
                          },
                          on: { click: _vm.initQrcode }
                        },
                        [_vm._v("刷新")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          : _c(
              "el-form",
              {
                ref: "form",
                attrs: { inline: true, model: _vm.form, rules: _vm.rules }
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "", prop: "validateCode" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入验证码" },
                      model: {
                        value: _vm.form.validateCode,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "validateCode", $$v)
                        },
                        expression: "form.validateCode"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "default", disabled: _vm.isDisabled },
                        on: { click: _vm.sendWeiXinCode }
                      },
                      [_vm._v(_vm._s(_vm.verifyCodeInText))]
                    )
                  ],
                  1
                )
              ],
              1
            )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e86a9f7a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e86a9f7a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GzhQRCode.vue
// module id = null
// module chunks = 